import SectionLayout from "../components/SectionLayout";
import SectionHeader from "../components/SectionHeader";
import ProjectCard from "../components/ProjectCard";
import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Projects() {
  const [expand, setExpand] = useState(false);
  const [data, setData] = useState([{}]);

  useEffect(() => {
    const prepareData = async () => {
      const querySnapshot = await getDocs(collection(db, "projects"));

      const dataArray = [];
      querySnapshot.forEach((doc) => dataArray.push(doc.data()));
      setData(dataArray);
    };
    prepareData();
  }, []);

  return (
    <SectionLayout id="projects" index={3}>
      <SectionHeader className="mb-20 ">Projects</SectionHeader>
      {/* perojects list */}
      {!!data.length &&
        data.map((element, index) => {
          if (index <= 1)
            return <ProjectCard key={element.id} data={element} />;
          else {
            if (expand) {
              return <ProjectCard key={element.id} data={element} />;
            }
            return null;
          }
        })}

      {/* show more button */}
      <button
        onClick={() => {
          setExpand((oldValue) => !oldValue);
        }}
        className="w-full p-2 text-lg font-bold text-black bg-white wide-button"
      >
        <div>Show {!expand ? "All" : "Less"}</div>
      </button>
    </SectionLayout>
  );
}
